import { render, staticRenderFns } from "./CollectionImagesForm.vue?vue&type=template&id=3065c05a&scoped=true&"
import script from "./CollectionImagesForm.vue?vue&type=script&lang=js&"
export * from "./CollectionImagesForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionImagesForm.vue?vue&type=style&index=0&id=3065c05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065c05a",
  null
  
)

export default component.exports